import { useAppStore } from "@/global/store";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";
import React from "react";
import { useTimeoutWorker } from "@/shared/modules/PurchaseSeats/timeout-worker/useTimeoutWorker";

export function CartTimeoutContainer() {
  const { timeoutWorker } = useTimeoutWorker();
  const cartState = useAppStore(selectCartManager);

  React.useEffect(() => {
    if (!cartState.cartId) return;
    timeoutWorker?.start();
  }, [cartState.cartId]);

  React.useEffect(() => {
    return () => timeoutWorker?.reset();
  }, []);

  return <></>;
}
